import { render, staticRenderFns } from "./CreateTaxSettingsModal.vue?vue&type=template&id=4a24f352&"
import script from "./CreateTaxSettingsModal.vue?vue&type=script&lang=js&"
export * from "./CreateTaxSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a24f352')) {
      api.createRecord('4a24f352', component.options)
    } else {
      api.reload('4a24f352', component.options)
    }
    module.hot.accept("./CreateTaxSettingsModal.vue?vue&type=template&id=4a24f352&", function () {
      api.rerender('4a24f352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/TaxSettings/CreateTaxSettingsModal.vue"
export default component.exports